import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "../contexts";
import DataLoader from "./DataLoader";

export default function ProtectedRoute({ children }) {
  const navigate = useNavigate();
  const { user } = useUserContext();

  useEffect(() => {
    if (user === null) {
      navigate("/login?next=" + window.location.pathname);
    }
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  if (user) {
    return <DataLoader>{children}</DataLoader>;
  }
}
